import { computed, reactive } from 'vue';
import { defineStore } from 'pinia';
import { SetupStoreId } from '@/store/plugins';
import { localStg } from '@/utils/storage';

export const useThemeStore = defineStore(SetupStoreId.Theme, () => {
  /** 主题相关配置 */
  const theme = reactive({
    /** 暗黑模式 */
    darkMode: localStg.get('darkMode') || false,
    /** 主题颜色 */
    themeColor: localStg.get('themeColor') || '#1890ff',
    /** 页面切换动画 */
    pageAnimateMode: localStg.get('pageAnimateMode') || 'fade-slide',
    /** 是否显示面包屑 */
    showBreadcrumb: localStg.get('showBreadcrumb') ?? true,
    /** 是否显示页脚 */
    showFooter: localStg.get('showFooter') ?? true,
    /** 是否显示页面切换动画 */
    showPageAnimate: localStg.get('showPageAnimate') ?? true
  });

  /** css变量字符串 */
  const cssVarsRef = computed(() => {
    const themeColor = theme.themeColor;
    const darkMode = theme.darkMode;

    const cssVars = {
      '--primary-color': themeColor,
      '--dark-mode': darkMode ? 'true' : 'false'
    };

    return cssVars;
  });

  /**
   * 设置暗黑模式
   * @param darkMode 暗黑模式
   */
  function setDarkMode(darkMode: boolean) {
    theme.darkMode = darkMode;
    localStg.set('darkMode', darkMode);
  }

  /**
   * 切换暗黑模式
   */
  function toggleDarkMode() {
    setDarkMode(!theme.darkMode);
  }

  /**
   * 设置主题颜色
   * @param themeColor 主题颜色
   */
  function setThemeColor(themeColor: string) {
    theme.themeColor = themeColor;
    localStg.set('themeColor', themeColor);
  }

  /**
   * 设置页面切换动画
   * @param mode 切换动画
   */
  function setPageAnimateMode(mode: string) {
    theme.pageAnimateMode = mode;
    localStg.set('pageAnimateMode', mode);
  }

  /**
   * 设置是否显示面包屑
   * @param show 是否显示
   */
  function setShowBreadcrumb(show: boolean) {
    theme.showBreadcrumb = show;
    localStg.set('showBreadcrumb', show);
  }

  /**
   * 设置是否显示页脚
   * @param show 是否显示
   */
  function setShowFooter(show: boolean) {
    theme.showFooter = show;
    localStg.set('showFooter', show);
  }

  /**
   * 设置是否显示页面切换动画
   * @param show 是否显示
   */
  function setShowPageAnimate(show: boolean) {
    theme.showPageAnimate = show;
    localStg.set('showPageAnimate', show);
  }

  return {
    theme,
    cssVarsRef,
    setDarkMode,
    toggleDarkMode,
    setThemeColor,
    setPageAnimateMode,
    setShowBreadcrumb,
    setShowFooter,
    setShowPageAnimate
  };
}); 